import api from "@/api";
import type { AxiosResponse } from "axios";

type RefreshResponse = AxiosResponse<{ authorisation: { token: string } }>;

export const jwtStore = defineStore("jwt", {
  state: () => ({
    jwt: "" as string,
    inFlightRefresh: null as Promise<RefreshResponse> | null,
  }),
  actions: {
    async setJwt(payload: string) {
      this.jwt = payload;
    },
    refreshOnce(): Promise<RefreshResponse> {
      if (this.inFlightRefresh) return this.inFlightRefresh;
      this.inFlightRefresh = (api.get("auth/refreshJwt") as Promise<RefreshResponse>).finally(() => {
        this.inFlightRefresh = null;
      });
      return this.inFlightRefresh;
    },
    async jwtLogout() {
      await this.setJwt("");
      localStorage.removeItem("jwt");
      const store = userStore();
      await store.userLogout();
      const router = useRouter();
      router.push({
        name: "language",
        params: {
          language: router.currentRoute.value.params.language ?? "pt-br",
        },
      });
    },
  },
  persist: {
    key: "jwt",
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ["jwt"],
  },
});
